import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import RetailPartnerService from 'service/RetailPartnerService/RetailPartnerService';
import UserBasicInfoCard from 'component/userDetailModal/components/UserBasicInfoCard';
import UserDeviceInfoCard from 'component/userDetailModal/components/UserDeviceInfoCard';
import RetailPartnerStoreInfoCard from './components/RetailPartnerStoreInfoCard';
import { RetailPartnerDetailByOwnerDto } from 'domain/payload/response/retailPartner/RetailPartnerResp';

const MerchantPartnerOwnerDetailModal: React.FC<{
  show: boolean;
  onClose: () => void;
  ownerId?: string;
}> = ({ show, onClose, ownerId }) => {
  const { profile } = useSelector((state: any) => state.auth);
  const [ownerData, setOwnerData] = useState<RetailPartnerDetailByOwnerDto | null>(null);
  const [loading, setLoading] = useState(false);

  const retailPartnerService = RetailPartnerService();

  const fetchOwnerDetail = async () => {
    if (!ownerId) return;

    const token = profile?.data.token;
    if (!token) return;

    setLoading(true);
    try {
      const response = await retailPartnerService.getDetailByOnwer(token, ownerId);
      setOwnerData(response.data || null);
    } catch (err) {
      console.error('Error fetching owner detail:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleWhatsAppClick = (phoneNumber: string) => {
    if (!phoneNumber) return;

    const cleanNumber = phoneNumber.replace(/\D/g, '');
    let whatsappNumber = cleanNumber;

    if (whatsappNumber.startsWith('0')) {
      whatsappNumber = '62' + whatsappNumber.substring(1);
    }

    window.open(`https://wa.me/${whatsappNumber}`, '_blank');
  };

  useEffect(() => {
    if (show && ownerId) {
      fetchOwnerDetail();
    }
  }, [show, ownerId]);

  useEffect(() => {
    if (!show) {
      setOwnerData(null);
    }
  }, [show]);

  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content position-relative">
          {loading && (
            <div
              className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
              style={{ backgroundColor: 'rgba(255,255,255,0.8)', zIndex: 9999 }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          <div className="modal-header">
            <h5 className="modal-title">Retail Partner Owner Detail</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
              disabled={loading}
            ></button>
          </div>

          <div className="modal-body">
            {ownerData ? (
              <div className="row">
                <div className="col-md-6 mb-4">
                  <UserBasicInfoCard
                    userInfo={ownerData.basicInfo}
                    onWhatsAppClick={handleWhatsAppClick}
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <UserDeviceInfoCard userInfo={ownerData.basicInfo} />
                </div>
                <div className="col-12 mb-4">
                  <RetailPartnerStoreInfoCard storeInfo={ownerData.storeInfo} />
                </div>
              </div>
            ) : (
              !loading && (
                <div className="text-center py-4">
                  <i className="fa-solid fa-exclamation-triangle fa-3x text-muted mb-3"></i>
                  <p className="text-muted">No owner data available</p>
                </div>
              )
            )}
          </div>

          <div className="modal-footer border-top">
            <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={loading}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantPartnerOwnerDetailModal;